import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import trackingService from '../services/trackingService';

export const useAffiliateCode = (eventName = 'affiliate_visit') => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const urlAff = searchParams.get('aff');

    if (urlAff) {
      trackingService.setInfluencer(urlAff);
      trackingService.track(eventName, { affiliateCode: urlAff });
      console.log('✅ Affiliate code set from URL:', urlAff);
    } else {
      const storedAff = trackingService.getCurrentInfluencerId();
      if (storedAff) {
        console.log('✅ Using stored affiliate code:', storedAff);
      }
    }
  }, [searchParams, eventName]);

  return searchParams.get('aff') || trackingService.getCurrentInfluencerId() || null;
};
